import { injectable } from 'tsyringe';
import { LaporanKepesantrenanApiRepository } from '../../app/repository/api/LaporanKepesantrenanApiRepository';

@injectable()
export class LaporanKepesantrenanPresenter {
  private repository: LaporanKepesantrenanApiRepository;

  constructor(repository: LaporanKepesantrenanApiRepository) {
    this.repository = repository;
  }

  public getList(page: number, rows: number, namaPesantren: string, peran: string) {
    return this.repository.getList(page, rows, namaPesantren, peran);
  }

  public exportExcel(namaPesantren: string, peran: string) {
    return this.repository.exportExcel(namaPesantren, peran);
  }

  public getRekap(pelatihanId?: string) {
    return this.repository.getRekap(pelatihanId);
  }

  public getPelatihanPesantren() {
    return this.repository.getPelatihanPesantren();
  }
}
